<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="accountId"
                clearable
                v-model="accountId"
                size="mini"
              >
              </el-input>
            </div>
          </div>

          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="交易对"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.symbol"
                  :label="item.symbol.toLocaleUpperCase()"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-date-picker
                v-model="times"
                type="daterange"
                format="yyyy 年 MM 月 dd 日"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                size="mini"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" @click="clearFiled">重置</el-button>
          </div>
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="500">
        <el-table-column label="交易对" prop="symbol" align="center" />
        <el-table-column prop="userId" label="accountId" align="center" />
        <el-table-column label="带单分润(折U)" prop="divideU" align="center" />
        <el-table-column
          label="跟单员收益(折U)"
          prop="followerProfitU"
          align="center"
        />
        <el-table-column
          label="跟单者交易额(U)"
          prop="followerTradeAmount"
          align="center"
        />
        <el-table-column
          label="开仓本金(折U)"
          prop="openMarginU"
          align="center"
        />

        <el-table-column prop="tradeAmount" label="交易额(U)" align="center" />
        <el-table-column label="平仓盈亏(折U)" prop="profitU" align="center" />
        <el-table-column label="收益" prop="income" align="center" />
        <el-table-column prop="" label="收益率" align="center">
          <template slot-scope="scope">
            <span
              >{{
                new BigNumber(scope.row.incomeRate)
                  .times(100)
                  .toFixed(2, BigNumber.ROUND_DOWN)
              }}%</span
            >
          </template>
        </el-table-column>

        <el-table-column label="亏损笔数" prop="lossCount" align="center" />
        <el-table-column label="赢利笔数" prop="profitCount" align="center" />
        <el-table-column label="持仓时间(m)" prop="positionTime" align="center">
          <template slot-scope="scope">
            <span>{{
              new BigNumber(scope.row.positionTime)
                .div(60000)
                .toFixed(1, BigNumber.ROUND_DOWN)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最近一次交易时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.lastTradeTime | moment }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";
import BigNumber from "bignumber.js";
export default {
  components: {
    Pagination,
  },
  computed: {
    startDate() {
      return this.times ? this.times[0] : "";
    },
    endDate() {
      return this.times ? this.times[1] : "";
    },
  },
  data() {
    return {
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      symbolList: [],
      symbolId: "",
      accountId: "",
      times: [],
    };
  },
  computed: {},
  mounted() {
    api.getSymbolList({ type: "CONTRACT" }).then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    clearFiled() {
      this.symbolId = "";
      this.accountId = "";
      this.times = [];
      this.handleSearch({ page: 1 });
    },
    handleSearch(data = {}) {
      api
        .copytradeLeaderStat({
          symbolId: this.symbolId,
          accountId: this.accountId,
          startTime: this.times && this.times[0] ? this.times[0] : "",
          endTime: this.times && this.times[1] ? this.times[1] : "",
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { total, items } = res.data;
            this.tabList = items;
            this.totalCount = total;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
.avatar {
  width: 50px;
  height: 50px;
}
</style>
